import Wrapper from "~/components/Playground/Node/CommandStepNode/Wrapper";

interface Props {
  paths: string[];
}

export default function ArtifactPaths({ paths }: Props) {
  if (!paths.length) {
    return null;
  }

  return (
    <Wrapper title="Artifacts" icon="heroicons/20/solid/cube">
      <ul className="flex flex-row flex-wrap gap-2">
        {paths.map((path) => (
          <li
            key={path}
            className="shadow-depth-200 inline-block cursor-default rounded-lg bg-white px-3 py-1"
          >
            <span className="code text-charcoal-700 max-w-full truncate text-sm ...">{path}</span>
          </li>
        ))}
      </ul>
    </Wrapper>
  );
}
